export default {
    login: {
        title: '用户登录',
        username: 'PANACRO博纳西亚',
        button: '登录',
        confirmBtn: '确定',
        forgotPassword: '忘记密码',
        userAgreement: '用户协议',
        privacyPolicy: '隐私政策',
        aggreStr1: '我已阅读并同意',
        aggreStr2: '和',
        agreeStr3: '，并同意将我的数据用于产品改进和个性化推荐。',
        switchAccount: '更换账号',
        confirmlogin: '确认登录',
        platformPrivacyPolicy: "临床试验云平台隐私政策",
        platformUserAgreement: '临床试验云平台用户协议',
        tip: '温馨提示',
        disagree: '不同意',
        agreeStr4: '为了更好地保障您的合法权益，请您阅读并同意',
        tabName1: '账号密码登录',
        tabName2: '手机验证登录',
        placeholderStr1: '请输入用户名/邮箱/手机号',
        placeholderStr2: '请输入密码',
        placeholderStr3: '请输入手机号',
        placeholderStr4: '请输入验证码',
        placeholderStr5: '请输入邮箱/手机号',
        placeholderStr6: '请输入邮箱',
        verificationCode: '获取验证码',
        retrievePassword: '找回密码',
        resetPassword: '重设密码',
        next: '下一步',
        backLogin: '返回登录',
        warnStr1: '请联系管理员',
    },
    iphone: {
        warnStr1: '请输入正确手机号',
        warnStr2: '发送成功！请注意查收',
        warnStr3: '重新发送',
        warnStr4: '点击按钮进行邮箱验证',
        warnStr5: '点击按钮进行手机验证',
        warnStr6: '账号尚未注册',
        warnStr7: '发送成功！请注意查收',
        warnStr8: '验证码已发送邮箱',
        warnStr9: '验证手机号',
    },
    forgetPassword: {
        tpisStr1: '确认新密码不能低于6位',
        tpisStr2: '新密码不能低于6位',
        tpisStr3: '确认新密码不符合格式要求',
        tpisStr4: '新密码不符合格式要求',
        tpisStr5: '新密码与确认密码不一致',
        tpisStr6: '新密码',
        tpisStr7: '长度为6~18个字符,数字,大小写字母和标点符号至少包含两种',
        tpisStr8: '请输入新密码',
        tpisStr9: '确认新密码',
        tpisStr10: '请输入确认密码',
        tpisStr11: '重设密码',
        tpisStr12: '密码重置成功',
        tpisStr13: '去登录',
        tpisStr14: '设置新密码',
        tpisStr15: '确认并登录',
        tpisStr16: '新用户或重置密码用户首次登录需设置新密码',
    },
    validate: {
        str1: '已发送验证码,请查看短信并输入获取的验证码',
        str2: '验证码已发送至',
        str3: ',请查看邮箱并输入获取的验证码',
        str4: '请输入验证码',
        str5: '收不到验证码？',
        str6: '换个手机号',
        str7: '换个邮箱',
        str8: '下一步',
        str9: '邮箱验证',
        str10: '（当前用户未绑定邮箱，请联系管理员）',
        warnStr1: '请输入手机号',
        warnStr2: '请输入正确手机号',
        warnStr3: '请输入用户名',
        warnStr4: '请输入密码',
        warnStr5: '请输入6位验证码',
        warnStr6: '请输入正确验证码',
        warnStr7: '请输入手机号或者邮箱',
        warnStr8: '请输入正确手机号或邮箱',
        warnStr9: '请输入新密码',
        warnStr10: '请输入确认密码',
    },
}
